export class Update {
	userID: string;
	oldPwd: string;
	newPwd: string;
}
